import type { FormikHelpers, FormikValues } from "formik";
import { FormAdapter } from "hooks/useForm";
import { useSimpleRequest } from "hooks";
import useUser from "features/auth/useUser";
import { getOnboardingsApplications } from "features/ecommerce/api";
import useOnboardingAction from "./useOnboardingAction";
import useOnboardingStep from "./useOnboardingStep";
import type { WithForm } from "./types";

export const useOnboardingForm = <T extends object>({ onSuccess, ...settings }: WithForm<T>) => {
    const { navigateForward } = useOnboardingStep(settings);
    const { complete } = useOnboardingAction(settings);
    const request = useSimpleRequest();
    const { user } = useUser();

    return async (fields: Partial<T>, formHelpers?: FormikHelpers<FormikValues>) => {
        const response = await complete(fields as T, {
            onSuccess: () => {
                formHelpers!.setTouched({});

                return request(() => getOnboardingsApplications({
                    userId: user.coreId
                }), {
                    onSuccess: onSuccess ?? navigateForward
                });
            }
        });

        return FormAdapter.fromResponse(response);
    };
};

export default useOnboardingForm;
